import { Subscription } from './subscriptions.model';
import { Actions, LOAD_SUBSCRIPTION, LOAD_SUBSCRIPTION_FAILURE, LOAD_SUBSCRIPTION_SUCCESS } from './subscriptions.actions';

export interface SubscriptionsState {
  subscriptions: Subscription[];
  loading: boolean;
};
export const /** @type {?} */ initialState: SubscriptionsState = {
  subscriptions: [],
  loading: false
};
/**
 * @param {?=} state
 * @param {?=} action
 * @return {?}
 */
export function reducer(state: SubscriptionsState = initialState, action: Actions): SubscriptionsState {
  switch (action.type) {
    case LOAD_SUBSCRIPTION: {
      return Object.assign({}, state, {
        loading: true
      });
    }
    case LOAD_SUBSCRIPTION_SUCCESS: {
      const /** @type {?} */ subscriptions = action.payload;
      return {
        subscriptions,
        loading: false
      };
    }
    case LOAD_SUBSCRIPTION_FAILURE: {
      const /** @type {?} */ subscriptions: Subscription[] = [];
      return {
        subscriptions,
        loading: false
      };
    }
    default:
      return state;
  }
}
export const /** @type {?} */ getsubscriptions = (state: SubscriptionsState) => state.subscriptions;
export const /** @type {?} */ getloading = (state: SubscriptionsState) => state.loading;
